// REACT
import React, { Component } from "react";
import { withRouter } from 'react-router-dom';

// REDUX
import { connect } from 'react-redux';
import * as actions from 'actions';

// STYLING
import { FluidSection } from 'components';
import styled from 'styled-components';
import { constants } from '../../constants';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

// UTILITIES
import { getCompanyTimezone } from '../../utils/timezoneUtils';
import getSbmClient from '../../utils/getSbmClient';
import moment from 'moment-timezone';
import cloneDeep from "lodash/cloneDeep";
import sortAvailabilityTimesInConsumerTimeByConsumerDays from './utils/sortAvailabilityTimesInConsumerTimeByConsumerDays';
import sortAvailabilityTimesInCynoTimeByCynoDays from './utils/sortAvailabilityTimesInCynoTimeByCynoDays';
import sortExceptionTimesInConsumerTimeByConsumerDates from './utils/sortExceptionTimesInConsumerTimeByConsumerDates';
import sortExceptionTimesinCynoTimeByCynoDates from './utils/sortExceptionTimesinCynoTimeByCynoDates';
import sortAndCombineDayOfTimeblocks from './utils/sortAndCombineDayOfTimeblocks';
import removeExceptionTimeBlock from './utils/removeExceptionTimeBlock';
import removeTimeBlock from './utils/removeTimeBlock';
import getParamsForDeletion from './utils/getParamsForDeletion';
import findIndexToRemove from './utils/findIndexToRemove';
import createDayOff from './utils/createDayOff';
import getParamsToDeleteExceptionDayOff from './utils/getParamsToDeleteExceptionDayOff';
import buildSbmParams from './utils/buildSbmParams.js';

// COMPONENTS
import StyledCardComponent from './components/StyledCardComponent';
import StyledExceptionDayComponent from './components/StyledExceptionDayComponent';
import StyledDayOffComponent from './components/StyledDayOffComponent';
import AvailabilityModalDialog from './components/AvailabilityModalDialog';
import AvailabilityModalWindow from './components/AvailabilityModalWindow';
import Button from 'components/Primatives/Button';
import H1 from 'components/Primatives/H1';
import H2 from 'components/Primatives/H2';
import H3 from 'components/Primatives/H3';
import PText from 'components/Primatives/PText';
import FlexColumn from 'components/Primatives/FlexColumn';
import FlexRow from 'components/Primatives/FlexRow';
import BackgroundImg from 'components/Primatives/BackgroundImg';
import IconButton from 'components/Button/IconButton';
import CircularProgress from 'material-ui/CircularProgress';
import DatePicker from 'material-ui/DatePicker';
import CompanyBreadcrumbs from 'components/Assests/CompanyBreadcrumbs';


const StyledExceptionContainer = styled.div`
    display: flex;
    flex: 1;
    justify-self: stretch;
    align-self: stretch;
    flex-flow: column  nowrap;
    /* max-width: 50vw; */
    /* height: auto; */
    justify-content: start;
    align-content: center;
    align-items: center;
    background-color: white;
    color: ${constants.color.primaryDark};
    border-radius: 5px;
    margin: 8px;
    box-shadow: -1px 1px 5px rgba(0, 0, 0, 0.2);
    flex: 1;
    padding: 40px 60px;
`;


class ProviderContainer extends Component {
    constructor(){
        super();
        this.state = {
            startTime: '',
            endTime: '',
            defaultDate: new Date(),
            availabilityInConsumerTime: {
                "1": [],
                "2": [],
                "3": [],
                "4": [],
                "5": [],
                "6": [],
                "7": [],
            }, 
            exceptionsInConsumerTime: {},
            datesOff: {},
            exceptionCardData: {},
            newException: [],
            newExceptionForComparison: [],
            exceptionDate: "",
            showDatePicker: false,
            showExceptionCard: false,
            loading: true,
            loadingMessage: null,
            providerId: "",
            isDialogOpen: false,
            dialogTitle: null,
            dialogBody: null,
            dialogAction: null
        };
    };

    componentDidMount(){
        const providerId = this.props.match.params.id;
        this.props.getProviderData(providerId)
            .then(getProviderDataResponse => {
                if (getProviderDataResponse) {
                    this.setState({
                        loading: false,
                        providerId: providerId,
                    });
                };
            });
    };

    componentDidUpdate(prevProps){
        if (this.props.availability !== prevProps.availability) {
            const availabilityDaysInCynoTime = cloneDeep(this.props.availability);
            let availabilityInConsumerTime = {
                "1": [],
                "2": [],
                "3": [],
                "4": [],
                "5": [],
                "6": [],
                "7": [],
            };
            Object.keys(availabilityDaysInCynoTime).map((day, index) => {
                // THIS SETS THE DAY TO 7(SUNDAY)
                const today = parseInt(day, 10) === 0 ? 7: parseInt(day, 10);
                if (typeof availabilityDaysInCynoTime[day][0] !== 'string') {
                    availabilityDaysInCynoTime[day].map(timeBlock => {
                        const availabilityTimeBlockInConsumerTime = this.convertTimeBlock([timeBlock], today, "toLocal");
                        availabilityInConsumerTime = sortAvailabilityTimesInConsumerTimeByConsumerDays(availabilityTimeBlockInConsumerTime, today, availabilityInConsumerTime);
                    });
                };
            });
            Object.keys(availabilityInConsumerTime).map((day, index) => {
                if (availabilityInConsumerTime[day].length > 0) {
                    availabilityInConsumerTime[day] = sortAndCombineDayOfTimeblocks(availabilityInConsumerTime[day]);
                };
            });
            this.setState({
                availabilityInConsumerTime: availabilityInConsumerTime,
                loading: false,
                loadingMessage: null,
                isDialogOpen: false,
                dialogAction: null,
                dialogBody: null,
                dialogContent: null
            });
        };

        if (this.props.exceptions !== prevProps.exceptions) {
            const exceptionsInCynoTime = cloneDeep(this.props.exceptions);
            let exceptionsInConsumerTime = {};
            Object.keys(exceptionsInCynoTime).map((date, index) => {
                const dateMoment = moment(date);
                let dateIndex = dateMoment.day();
                if (dateIndex === 0) {
                    dateIndex = 7;
                };
                exceptionsInCynoTime[date].map(timeBlock => {
                    const exceptionTimeBlockInConsumerTime = this.convertTimeBlock([timeBlock], dateIndex, "toLocalException");
                    exceptionsInConsumerTime = sortExceptionTimesInConsumerTimeByConsumerDates(exceptionTimeBlockInConsumerTime, date, exceptionsInConsumerTime, exceptionsInCynoTime);
                });
            });
            Object.keys(exceptionsInConsumerTime).map((date, index) => {
                exceptionsInConsumerTime[date] = sortAndCombineDayOfTimeblocks(exceptionsInConsumerTime[date]);
            });
           
            this.setState({
                exceptionsInConsumerTime: exceptionsInConsumerTime,
                loading: false,
                loadingMessage: null,
                isDialogOpen: false,
                dialogAction: null,
                dialogBody: null,
                dialogContent: null
            });
        };

        if (this.props.datesOff !== prevProps.datesOff) {
            this.setState({
                datesOff: this.props.datesOff,
                loading: false,
                loadingMessage: null,
                isDialogOpen: false,
                dialogAction: null,
                dialogBody: null,
                dialogContent: null
            });
        };

        if (this.props.availabilityUpdateStatus !== prevProps.availabilityUpdateStatus) {
            if (this.props.availabilityUpdateStatus === "success") {
                this.props.notifyUser({
                    message: 'Availability updated succesfully',
                    textColor: 'white'
                })
            };
            if (this.props.availabilityUpdateStatus === "failed") {
                this.props.notifyUser({
                    message: 'Failed to update availability',
                    textColor: 'red'
                })
                this.setState({
                    loading: false,
                    loadingMessage: null,
                    isDialogOpen: false,
                    dialogAction: null,
                    dialogBody: null,
                    dialogContent: null
                })
            };
        };
    };


    // EDIT BUTTON REDIRECT
    employeeEditorRedirect = () => {
        const { providerId } = this.state;
        const { providerData, updateLocation } = this.props;
        this.props.selectItem("STAFF", providerData)
            .then(onResponse => {
                this.props.history.push(`/company/employeeEditor/${providerId}`);
                updateLocation(`/company/employeeEditor/${providerId}`);
            })
    }


    // CONTROLLED COMPONENT FUNCTIONS
    grabStartTime = (e) => {
        e.preventDefault();
        this.setState({startTime: e.target.value});
    };

    grabEndTime = (e) => {
        e.preventDefault();
        this.setState({endTime: e.target.value});
    };


    // TIME CONVERTER
    convertTimeBlock = (timeBlock, dayIndex, conversionType) => {
        const sbmApiClient = getSbmClient();
        const todayDateString = moment().set('day', dayIndex).format("YYYY-MM-DD");
        const toZone = (conversionType === "toCynoTime") ? getCompanyTimezone(sbmApiClient) : moment.tz.guess();
        const fromZone = (conversionType === "toCynoTime") ? moment.tz.guess() : getCompanyTimezone(sbmApiClient);

        const convertTime = (localTime, todayDateString) => {
            const timeString = todayDateString.concat(" ", localTime);
            const timeMoment = moment.tz(timeString, fromZone);
            const newTime = timeMoment.tz(toZone).format().split("T");
            newTime[1] = newTime[1].slice(0,5);

            const time = newTime[1];
            const date = newTime[0];
            const dateTime = newTime.join(" ");
            if (date !== todayDateString) {
                return dateTime;
            }
            else return time;
        };
    
        const checkDate = (convertedTimeDateString, todayDateString) => {
            const convertedDateString = convertedTimeDateString.split(' ');
            let checkDateResult;
            if (convertedDateString[0] === moment(moment.utc(todayDateString)).add(1, 'd').format("YYYY-MM-DD")) {
                checkDateResult = true;
            }
            else {
                checkDateResult = false;
            }
            return checkDateResult;
        };
        let convertedBlock = [];
        timeBlock.map(time => {
            time[0] = convertTime(time[0], todayDateString);
            time[1] = convertTime(time[1], todayDateString);
            convertedBlock.push([...[time[0], time[1]]]);
        });

        const isStandardTimeStringLength = time => {
            // IF THE STRING LENGTH IS > 5 IT INCLUDES A DATE STRING MEANING AFTER TIME CONVERSION ANOTHER DAY IS AFFECTED
            return (time.length === 5) ? true : false;
        };

        let past = [];
        let today = [];
        let next = [];
        convertedBlock.map(timeBlock => {
            if (isStandardTimeStringLength(timeBlock[0]) && isStandardTimeStringLength(timeBlock[1])) {
                (timeBlock[1] === "00:00") ? today.push([timeBlock[0], "24:00"]) : today.push([timeBlock[0], timeBlock[1]]);
            }
            else if (!isStandardTimeStringLength(timeBlock[0]) && !isStandardTimeStringLength(timeBlock[1])) {
                if (checkDate(timeBlock[0], todayDateString)) {
                    next.push([timeBlock[0].split(" ")[1], timeBlock[1].split(" ")[1]]);
                }
                else {
                    past.push([timeBlock[0].split(" ")[1], timeBlock[1].split(" ")[1]]);
                };
            }
            else if (!isStandardTimeStringLength(timeBlock[0]) && isStandardTimeStringLength(timeBlock[1])) {
                past.push([timeBlock[0].split(" ")[1], "24:00"]);
                if (conversionType === "toCynoTime") {
                    today.push(["00:00", timeBlock[1]]);
                };
            }
            else if (isStandardTimeStringLength(timeBlock[0]) && !isStandardTimeStringLength(timeBlock[1])) {
                today.push([timeBlock[0], "24:00"]);
                if (conversionType === "toCynoTime" && timeBlock[1].split(" ")[1] !== "00:00") {
                    next.push(["00:00", timeBlock[1].split(" ")[1]]);
                };
            };
        });
        const convertedBlockSet = [past, today, next];
        return convertedBlockSet;
    };


    // RECURRING AVAILABILITY
    deleteRecurringTimeBlock = (deleteOptions) => {
        const {
            timeBlockIndex,
            day
        } = deleteOptions;
        const blockIndex = timeBlockIndex;
        const recurringDay = day;
        const conversionType = "toCynoTime";
        const availabilityOperation = "recurring";

        const availabilityInConsumerTime = cloneDeep(this.state.availabilityInConsumerTime);
        const blockToRemove = availabilityInConsumerTime[recurringDay][blockIndex];
        const convertedBlockSetToRemove = this.convertTimeBlock([blockToRemove], recurringDay, conversionType);
        const availabilityDaysInCynoTime = cloneDeep(this.props.availability);
        const SBMId = this.props.providerData.SBMId;
        if (!SBMId) {
            this.showErrorDialog()
        } else if (SBMId) {
            const sbmParamsObjectSet = removeTimeBlock(convertedBlockSetToRemove, recurringDay, availabilityOperation, availabilityDaysInCynoTime, SBMId);
            this.props.setProviderAvailability(this.state.providerId, sbmParamsObjectSet, availabilityOperation);
            this.setState({
                loading: true,
                loadingMessage: "This may take a moment..."
            }); 
        }
    };

    addTimeSection = (dayOrDate, operationType, conversionType) => {
        const exceptionsInCynoTime = cloneDeep(this.props.exceptions);
        const availabilityDaysInCynoTime = cloneDeep(this.props.availability);
        const SBMId = this.props.providerData.SBMId;
        if (!SBMId) {
            const errorMessage = `There appears to be a problem with your account.  Please contact Cyno support. We apologize for the inconvenience.`;
            this.showErrorDialog(errorMessage);
        } else if (SBMId) {
            const { startTime, endTime } = this.state;
            const startTimeNumber = parseFloat(startTime.replace(':', '.'));
            const endTimeNumber = parseFloat(endTime.replace(':', '.'));
            if (endTimeNumber <= startTimeNumber) {
                const errorMessage = `End time must be later than start time.`;
                this.showErrorDialog(errorMessage);
            } else {
                const timeBlockInCynoTime = this.convertTimeBlock([[startTime, endTime]], dayOrDate, conversionType);
                const sbmParamsAndAvailability = (operationType === "exception") 
                    ? sortExceptionTimesinCynoTimeByCynoDates(timeBlockInCynoTime, dayOrDate, operationType, exceptionsInCynoTime, availabilityDaysInCynoTime, SBMId)
                    : sortAvailabilityTimesInCynoTimeByCynoDays(timeBlockInCynoTime, dayOrDate, operationType, availabilityDaysInCynoTime, SBMId);
                console.log(sbmParamsAndAvailability)
                const exceptionToDelete = sbmParamsAndAvailability[2];
                if (exceptionToDelete) {
                    this.props.deleteProviderException(this.state.providerId, exceptionToDelete, operationType);
                }
                this.props.setProviderAvailability(this.state.providerId, sbmParamsAndAvailability, operationType);
                this.setState({
                    startTime: "",
                    endTime: "",
                    exceptionDate: moment().format("YYYY-MM-DD"),
                    showExceptionCard: false,
                    loading: true,
                    loadingMessage: "This may take a moment..."
                });
            };
        };
    };
    
    addEditRecurring = (day) => {
        const recurringDay = day;
        const operationType = "recurring";
        const conversionType = "toCynoTime";
        this.addTimeSection(recurringDay, operationType, conversionType);
    };


    // EXCEPTIONS
    deleteException = (deleteOptions) => {
        const {
            timeBlockIndex
        } = deleteOptions;
        const blockIndex = timeBlockIndex;
        const exceptionDate = this.state.exceptionDate;
        const conversionType = "toCynoTime";
        const availabilityOperation = "exception";
        const exceptionsInConsumerTime = cloneDeep(this.state.exceptionsInConsumerTime);
        const exceptionsInCynoTime = cloneDeep(this.props.exceptions);
        const SBMId = this.props.providerData.SBMId;
        if (!SBMId) {
            const errorMessage = `There appears to be a problem with your account.  Please contact Cyno support. We apologize for the inconvenience.`;
            this.showErrorDialog(errorMessage);
        } else if (SBMId) {
            const blockToRemove = exceptionsInConsumerTime[exceptionDate][blockIndex];
            const convertedBlockSetToRemove = this.convertTimeBlock([blockToRemove], exceptionDate, conversionType);
            const sbmParamsObjectSetAndAvailabilityArray = removeExceptionTimeBlock(
                convertedBlockSetToRemove,
                exceptionDate,
                availabilityOperation,
                exceptionsInCynoTime,
                SBMId);
            this.checkParamsAndDispatch(sbmParamsObjectSetAndAvailabilityArray);
        };
    };

    checkParamsAndDispatch = (sbmParamsObjectSetAndAvailabilityArray) => {
        const sbmDeleteParamsObject = sbmParamsObjectSetAndAvailabilityArray[0].deleteDates;
        const deleteParamsLength = sbmDeleteParamsObject.length;
        const sbmExceptionParamsObject = sbmParamsObjectSetAndAvailabilityArray[0].exceptionsSet;
        const exceptionParamsLength = Object.keys(sbmExceptionParamsObject).length;
        const exceptionsInCynoTime = sbmParamsObjectSetAndAvailabilityArray[1];

        const { setProviderAvailability, deleteProviderException } = this.props;
        const { providerId } = this.state;

        if (deleteParamsLength === 0) {
            const newExceptionParamsObjectSet = {0: sbmExceptionParamsObject, 1: exceptionsInCynoTime};
            setProviderAvailability(providerId, newExceptionParamsObjectSet, "exception");
        }
        else if (exceptionParamsLength === 0) {
            deleteProviderException(providerId, sbmDeleteParamsObject, "deleteException");
        }
        else if (deleteParamsLength > 0 && exceptionParamsLength === 0) {
            deleteProviderException(providerId, sbmDeleteParamsObject, "deleteException");
        }
        else {
            const newExceptionParamsObjectSet = {0: sbmExceptionParamsObject, 1: exceptionsInCynoTime};
            deleteProviderException(providerId, sbmDeleteParamsObject, "deleteException");
            setProviderAvailability(providerId, newExceptionParamsObjectSet, "exception");
        }
        this.setState({
            showExceptionCard: false,
            loading: true,
            loadingMessage: "This may take a moment..."
        });
    };

    deleteExceptionDay = (date) => {
        const exceptionDate = date;
        const exceptionDayIndex = (moment(date).day() === 0) ? 7 : moment(date).day();
        const conversionType = "toCynoTime";
        const operationType = "exception";
        const localTimeExceptions = cloneDeep(this.state.exceptionsInConsumerTime[exceptionDate]);
        const exceptionsInCynoTime = cloneDeep(this.props.exceptions);
        const SBMId = this.props.providerData.SBMId;
        if (!SBMId) {
            const errorMessage = `There appears to be a problem with your account.  Please contact Cyno support. We apologize for the inconvenience.`;
            this.showErrorDialog(errorMessage);
        } else if (SBMId) {
            const sortedDeletions = this.convertTimeBlock(localTimeExceptions, exceptionDayIndex, conversionType);
            const sbmParamsObjectSetAndAvailabilityArray = getParamsForDeletion(sortedDeletions, exceptionDate, operationType, exceptionsInCynoTime, SBMId);
            this.checkParamsAndDispatch(sbmParamsObjectSetAndAvailabilityArray);
            this.setState({
                exceptionDate: "",
                exceptionCardData: {},
                newException: [],
                newExceptionForComparison: [],
                showExceptionCard: false,
                loading: true,
                loadingMessage: "This may take a moment..."
            }); 
        };
    };
    
    addEditException = () => {
        const exceptionDate = this.state.exceptionDate;
        const operationType = "exception";
        const conversionType = "toCynoTime";
        this.addTimeSection(exceptionDate, operationType, conversionType);
    };
    
    deleteExceptionDayOff = (date) => {
        const exceptionDayOffDate = date;
        const conversionType = "toCynoTime";
        const operationType = "deleteExceptionDayOff";
        const exceptionsInCynoTime = cloneDeep(this.props.exceptions);
        
        const startTime = "00:00";
        const endTime = "24:00";
        const convertedDayOff = this.convertTimeBlock([[startTime, endTime]], exceptionDayOffDate, conversionType);

        const sbmParamsObjectSet = getParamsToDeleteExceptionDayOff(exceptionDayOffDate, convertedDayOff, exceptionsInCynoTime);
        const { deleteDates, exceptionsToResend } = sbmParamsObjectSet;

        const { deleteProviderException, resendProviderExceptions } = this.props;
        const { providerId } = this.state;
        if (deleteDates.length > 0 && exceptionsToResend.length > 0) {
            deleteProviderException(providerId, [exceptionDayOffDate, deleteDates], operationType);
            resendProviderExceptions(providerId, exceptionsToResend);
        }
        else if (deleteDates.length > 0 && exceptionsToResend.length === 0) {
            deleteProviderException(providerId, [exceptionDayOffDate, deleteDates], operationType);
        }
        else if (deleteDates.length === 0 && exceptionsToResend.length > 0) {
            deleteProviderException(providerId, [exceptionDayOffDate], operationType);
            resendProviderExceptions(providerId, exceptionsToResend);
        };
        this.setState({
            loading: true,
            loadingMessage: "This may take a moment..."
        });
    };


    // NEW EXCEPTIONS
    addEditNewException = (e) => {
        const { startTime, endTime, providerId } = this.state;
        let newException = Array.from(this.state.newException);
        let exceptionCardData = cloneDeep(this.state.exceptionCardData);
        newException.push([startTime, endTime]);
        const sortedNewExceptionDay = sortAndCombineDayOfTimeblocks(newException);
        exceptionCardData.timeBlocks = sortedNewExceptionDay;
        this.setState({
            newException:sortedNewExceptionDay,
            exceptionCardData:exceptionCardData,
            isDialogOpen: false
        });
    };

    deleteFromNewException = (deleteOptions) => {
        const {
            timeBlockIndex
        } = deleteOptions;
        const deleteIndex = timeBlockIndex;
        let newException = Array.from(this.state.newException);
        let exceptionCardData = cloneDeep(this.state.exceptionCardData);
        newException.splice(deleteIndex, 1);
        exceptionCardData.timeBlocks = newException;
        this.setState({
            newException:newException,
            exceptionCardData:exceptionCardData,
            isDialogOpen: false
        });
    };

    saveNewException = (e) => {
        e.preventDefault();
        const newException = Array.from(this.state.newException);
        let newExceptionForComparison = Array.from(this.state.newExceptionForComparison);
        const exceptionDate = this.state.exceptionDate;
        const conversionType = "toCynoTime";
        const operationType = "exception"
        const exceptionDayIndex = (moment(exceptionDate).day() === 0) ? 7 : moment(exceptionDate).day();
        const SBMId = this.props.providerData.SBMId;
        if (!SBMId) {
            const errorMessage = `There appears to be a problem with your account.  Please contact Cyno support. We apologize for the inconvenience.`;
            this.showErrorDialog(errorMessage);
        } else if (SBMId) {
            if (newException.length === 0 && newExceptionForComparison.length === 0) {
                this.setState({
                    exceptionDate: "",
                    exceptionCardData: {},
                    newException: [],
                    newExceptionForComparison: [],
                    showExceptionCard: false,
                });
            }
            else if (newException.length === 0 && newExceptionForComparison.length > 0) {
                const convertedExceptionComparison = this.convertTimeBlock(newExceptionForComparison, exceptionDayIndex, conversionType);
                const exceptionsInCynoTime = cloneDeep(this.props.exceptions);
                const availabilityDaysInCynoTime = cloneDeep(this.props.availability);
                const datesOff = cloneDeep(this.state.datesOff);
                const startTime = "00:00";
                const endTime = "24:00";
                const convertedDayOff = this.convertTimeBlock([[startTime, endTime]], exceptionDate, conversionType);
                const sbmParamsArrayAndDatesOff = createDayOff(convertedDayOff, exceptionDate, convertedExceptionComparison, operationType, conversionType, exceptionsInCynoTime, availabilityDaysInCynoTime, datesOff, SBMId);
                const deleteDates = sbmParamsArrayAndDatesOff[0].deleteDates;
                const exceptionsSet = sbmParamsArrayAndDatesOff[0].exceptionsSet;
                const exceptionsInCynoTimeToSend = sbmParamsArrayAndDatesOff[1];
                const datesOffToSend = sbmParamsArrayAndDatesOff[2];
    
                const { setProviderAvailability, deleteProviderException } = this.props;
                const { providerId } = this.state;
                if (Object.keys(exceptionsSet).length > 0 && Object.keys(datesOff).length > 0) {
                    setProviderAvailability(providerId, [exceptionsSet, exceptionsInCynoTimeToSend, datesOffToSend], "addExceptionDayOff");
                }
                else if (Object.keys(exceptionsSet).length > 0) {
                    setProviderAvailability(providerId, [exceptionsSet, exceptionsInCynoTimeToSend], operationType);
                }
                if (deleteDates.length > 0) {
                    deleteProviderException(providerId, deleteDates, "deleteException");
                }
                this.setState({
                    exceptionDate: "",
                    exceptionCardData: {},
                    newException: [],
                    newExceptionForComparison: [],
                    showExceptionCard: false,
                    loading: true,
                    loadingMessage: "This may take a moment..."
                });            
            }
            else if (newException.length === newExceptionForComparison.length || newException.length > newExceptionForComparison.length) {
                newException.forEach(timeBlock => {
                    this.setState({
                        startTime: timeBlock[0],
                        endTime: timeBlock[1]
                    });
                    this.addTimeSection(exceptionDate, operationType, conversionType);
                });
            }
            else if (newException.length > 0) {
                newException.forEach(timeBlock => {
                    const indexToRemove = findIndexToRemove([timeBlock], newExceptionForComparison);
                    newExceptionForComparison.splice(indexToRemove, 1);
                });
                const timeBlocksToRemove = this.convertTimeBlock(cloneDeep(newExceptionForComparison), exceptionDayIndex, conversionType);
                const availabilityDaysInCynoTime = cloneDeep(this.props.availability);
                const newExceptionBlocksToSave = this.convertTimeBlock(newException, exceptionDate, conversionType);

                let exceptionsInCynoTime = cloneDeep(this.props.exceptions);
                if (exceptionsInCynoTime[exceptionDate]) {
                    delete exceptionsInCynoTime[exceptionDate]; 
                }
                
                const sbmParamsAndAvailability = sortExceptionTimesinCynoTimeByCynoDates(newExceptionBlocksToSave, exceptionDate, operationType, exceptionsInCynoTime, availabilityDaysInCynoTime, SBMId);

                let sbmExceptionParams = sbmParamsAndAvailability[0];
                
                const targetExceptionDayBlocksToRemove = timeBlocksToRemove[1];
                const targetExceptionDayBlocksToSave = newExceptionBlocksToSave[1];
                // THIS ENSURES WE SET AN EXCEPTION FOR DAYS AFFECTED AFTER TIMEZONE CONVERSION
                if (!targetExceptionDayBlocksToRemove.length && targetExceptionDayBlocksToSave.length) {
                    const exceptionParams = buildSbmParams(targetExceptionDayBlocksToSave, exceptionDate, operationType, SBMId);
                    sbmExceptionParams[exceptionDate] = exceptionParams;
                    exceptionsInCynoTime[exceptionDate] = targetExceptionDayBlocksToSave;
                    const paramsForOtherAffectedDay = removeTimeBlock(timeBlocksToRemove, exceptionDayIndex, operationType, availabilityDaysInCynoTime, SBMId);
                    const pastAdjustedDayIndex = (exceptionDayIndex - 1 === 0) ? 7 : exceptionDayIndex - 1;
                    const nextAdjustedDayIndex = (exceptionDayIndex + 1 === 8) ? 1 : exceptionDayIndex + 1;
                    let sbmIndexedExceptionParams = paramsForOtherAffectedDay[0];
                    let indexedExceptionArray = paramsForOtherAffectedDay[1];
                    for (let indexedExceptionDay in sbmIndexedExceptionParams) {
                        if (indexedExceptionDay) {
                            if (indexedExceptionDay === (pastAdjustedDayIndex).toString()) {
                                const pastDate = moment(moment.utc(exceptionDate)).add(-1, 'd').format("YYYY-MM-DD");
                                sbmIndexedExceptionParams[indexedExceptionDay].date = pastDate;
                                sbmExceptionParams[pastDate] = sbmIndexedExceptionParams[indexedExceptionDay];
                                exceptionsInCynoTime[pastDate] = indexedExceptionArray[indexedExceptionDay];
                            }
                            else if (indexedExceptionDay === (exceptionDayIndex).toString()) {
                                sbmIndexedExceptionParams[indexedExceptionDay].date = exceptionDate;
                                sbmExceptionParams[exceptionDate] = sbmIndexedExceptionParams[indexedExceptionDay];
                                exceptionsInCynoTime[exceptionDate] = indexedExceptionArray[indexedExceptionDay];
                            }
                            else if (indexedExceptionDay === (nextAdjustedDayIndex).toString()) {
                                const nextDate = moment(moment.utc(exceptionDate)).add(1, 'd').format("YYYY-MM-DD");
                                sbmIndexedExceptionParams[indexedExceptionDay].date = nextDate;
                                sbmExceptionParams[nextDate] = sbmIndexedExceptionParams[indexedExceptionDay];
                                exceptionsInCynoTime[nextDate] = indexedExceptionArray[indexedExceptionDay];
                            }
                        }
                    }
                }
                
                const sbmParamsAndAvailabilitySet = [sbmExceptionParams, exceptionsInCynoTime];
                this.props.setProviderAvailability(this.state.providerId, sbmParamsAndAvailabilitySet, operationType);
                this.setState({
                    exceptionDate: "",
                    exceptionCardData: {},
                    newException: [],
                    newExceptionForComparison: [],
                    showExceptionCard: false,
                    loading: true,
                    loadingMessage: "This may take a moment..."
                }); 
            };
        };
    };


    // CONFIRM DELETIONS
    confirmDelete = (deleteData, deleteType) => {
        switch (deleteType) {
            case "recurring":
                this.deleteRecurringTimeBlock(deleteData);
                break;
            case "exception":
                this.deleteException(deleteData);
                break;
            case "exceptionDay":
                this.deleteExceptionDay(deleteData);
                break;
            case "exceptionDayOff":
                this.deleteExceptionDayOff(deleteData);
                break;
            case "newException":
                this.deleteFromNewException(deleteData);
                break;
        }
    }


    // SHOW/HIDE UI COMPONENTS
    constructTimeList = (timeBlocks) => {
        let timeList = "Existing Times: ";
        timeBlocks.forEach(timeBlock => {
            let [ startTime, endTime ] = timeBlock;
            timeList += ` ${startTime}-${endTime}  `;
        });
        return timeList;
    };

    getDialogContent = (dialogContent, dialogTitleText, timeBlocks) => {
        const existingTimesList = this.constructTimeList(timeBlocks);
        const dialogTitle = {
            title: dialogTitleText,
            subtitle: `${existingTimesList}`,
            subtitleColor: 'blue',
            hasBorder: true,
        };
        this.setState({
            dialogTitle: dialogTitle,
            dialogBody: dialogContent,
            dialogAction: null
        }, () => {
            this.handleDialogStatusChange(true)})
    }

    showErrorDialog = (errorMessage) => {
        const dialogTitle = {
            title: 'Error',
            subtitle: errorMessage,
            subtitleColor: 'red',
            hasBorder: true,
        };
        const dialogAction = [
            <button
                key={1} 
                onClick={() => {
                    this.handleDialogStatusChange(false);
                    this.setState({dialogAction: null})
                }}
                style={{
                    width: "fit-content",
                    backgroundColor: "grey",
                    color: "white",
                    borderRadius: "15px",
                    borderStyle: "none",
                    padding: "10%",
                    margin: "10%"
                }}
            >
                OK
            </button>
        ];
        this.setState({
            dialogTitle,
            dialogAction,
            dialogBody: null
        }, () => this.handleDialogStatusChange(true));
    };

    showDeleteConfirmationDialog = (e, deleteData, deleteType, timeBlock = null) => {
        e.preventDefault();
        let subtitle;
        if (timeBlock) {
            const weekDayNames = ["Mondays", "Tuesdays", "Wednesdays", "Thursdays", "Fridays", "Saturdays", "Sundays"];
            const deleteTime = `${timeBlock[0]} - ${timeBlock[1]}`;
            const deleteDate = deleteType === 'recurring'
                ? `${weekDayNames[deleteData.day - 1]}`
                : `${deleteData.day}`;
            subtitle = `Deleting availability on ${deleteDate} at ${deleteTime}. Are you sure?`;
        } else {
            subtitle = `Deleting exception for ${deleteData}. Are you sure?`
        }
        const dialogTitle = {
            title: 'Confirm delete',
            subtitle,
            subtitleColor: 'blue',
            hasBorder: true,
        };
        const dialogAction = [
            <button
                key={1} 
                onClick={() => {
                    this.handleDialogStatusChange(false);
                    this.setState({dialogAction: null})
                }}
                style={{
                    width: "fit-content",
                    backgroundColor: "grey",
                    color: "white",
                    borderRadius: "15px",
                    borderStyle: "none",
                    padding: "7%",
                    margin: "10%"
                }}
            >
                Cancel
            </button>,
            <button 
                key={2}
                onClick={() => this.confirmDelete(deleteData, deleteType)}
                style={{
                    width: "fit-content",
                    backgroundColor: "#3fa9b4",
                    color: "white",
                    borderRadius: "15px",
                    borderStyle: "none",
                    padding: "7%",
                    margin: "10%"
                }}
            >
                Confirm
            </button>
        ]
        this.setState({
            dialogTitle: dialogTitle,
            dialogAction: dialogAction,
            dialogBody: null
        }, () => {
            this.handleDialogStatusChange(true)})
    }

    handleDialogStatusChange = (dialogDisplayStatus) => {
        this.setState({isDialogOpen: dialogDisplayStatus}, () => document.getElementById('top').scrollIntoView());
        
    };

    showExceptionCard = (event, date) => {
        const exceptionDate = moment(date).format("YYYY-MM-DD");
        let exceptionCardData = {};
        const dateString = moment(exceptionDate).format("dddd, MMMM Do YYYY");
        const { exceptionsInConsumerTime, availabilityInConsumerTime } = this.state;
        if (exceptionsInConsumerTime[exceptionDate]) {
            exceptionCardData = {
                cardName: exceptionDate,
                title: dateString,
                timeBlocks: cloneDeep(exceptionsInConsumerTime[exceptionDate]),
                addEditAvailability: this.addEditException,
                grabEndTime: this.grabEndTime,
                grabStartTime: this.grabStartTime,
                saveNewException: null,
                deleteType: "exception"
            };
        }
        else if (!exceptionsInConsumerTime[exceptionDate]) {
            const exceptionDateIndex = (moment(exceptionDate).day() === 0) ? 7 : moment(exceptionDate).day();
            const newTimeBlocks = cloneDeep(availabilityInConsumerTime[exceptionDateIndex]);
            this.setState({
                newException:newTimeBlocks,
                newExceptionForComparison:newTimeBlocks,
            });
            exceptionCardData = {
                cardName: exceptionDate,
                title: dateString,
                timeBlocks: newTimeBlocks,
                addEditAvailability: this.addEditNewException,
                grabEndTime: this.grabEndTime,
                grabStartTime: this.grabStartTime,
                saveNewException: this.saveNewException,
                deleteType: "newException"
            };
        };
        
        this.setState({
            exceptionDate: exceptionDate,
            exceptionCardData: exceptionCardData,
            showExceptionCard: true,
            showDatePicker: false,
        });
    };

    showDatePicker = (e) => {
        e.preventDefault();
        this.setState({showDatePicker: true});
    };

    hideDatePicker = () => {
        this.setState({showDatePicker: false})
    }


    render(){

        const localAvailability = this.state.availabilityInConsumerTime;
        const weekDayNames = ["Mondays", "Tuesdays", "Wednesdays", "Thursdays", "Fridays", "Saturdays", "Sundays"];
        let recurringCardsJSX = weekDayNames.map((day, i) => {
            return (
                <StyledCardComponent 
                    key={day} 
                    cardName={i + 1} 
                    title={day} 
                    timeBlocks={localAvailability[i + 1]} 
                    showDeleteConfirmationDialog={this.showDeleteConfirmationDialog} 
                    addEditAvailability={this.addEditRecurring} 
                    grabEndTime={this.grabEndTime} 
                    grabStartTime={this.grabStartTime} 
                    saveNewException={null}
                    getDialogContent={this.getDialogContent}
                    deleteType="recurring"
                />
            );
        });

        const exceptionsInConsumerTime = this.state.exceptionsInConsumerTime;
        let exceptionsInConsumerTimeDatesOnly = [];
        for (let dateOfExceptions in exceptionsInConsumerTime) {
            if (dateOfExceptions) exceptionsInConsumerTimeDatesOnly.push(dateOfExceptions);
        }

        let futureExceptions = exceptionsInConsumerTimeDatesOnly.filter((date, i) => {
            const todaysDate = moment().format("YYYY-MM-DD");
            if (!moment(date).isBefore(todaysDate)) {
                return true;
            }
        });
        
        let exceptionsJSX = futureExceptions.map((date, i) => {
            return <StyledExceptionDayComponent
                        key={i}
                        date={date}
                        showExceptionCard={this.showExceptionCard}
                        showDeleteConfirmationDialog={this.showDeleteConfirmationDialog} 
                        deleteType="exceptionDay"
                    />
        });

        const datesOffInConsumerTime = this.state.datesOff;
        let datesOffInConsumerTimeDates = [];
        for (let date in datesOffInConsumerTime) {
            if (date) datesOffInConsumerTimeDates.push(date);
        };

        let futureDaysOff = datesOffInConsumerTimeDates.filter((date, i) => {
            const todaysDate = moment().format("YYYY-MM-DD");
            if (!moment(date).isBefore(todaysDate)) {
                return true
            }
        });

        let daysOffJSX = futureDaysOff.map((date, i) => {
            return  <StyledDayOffComponent
                        date={date}
                        key={i}
                        showDeleteConfirmationDialog={this.showDeleteConfirmationDialog}
                        deleteType="exceptionDayOff"
                    />
        });

        const companyRoles = this.props.userData && this.props.userData.roles;


        const datePickerRef = React.createRef();
        const openDatePickerDialog = e => {
            if (datePickerRef.current) {
                datePickerRef.current.handleClick(e);
            }
        };

        return(
            <FlexColumn 
                style={{
                    backgroundColor: constants.color.grey5,
                    // alignSelf: 'center',
                    maxWidth: 'none',
                    alignSelf: 'stretch',
                    alignItems: 'center',
                }}
            >
                { this.props.match && this.props.match.params && this.props.match.params.id && companyRoles &&
                    <CompanyBreadcrumbs
                        employeeId={this.props.match.params.id}
                        location={this.props.match.url}
                        companyRoles = {companyRoles}
                    />
                }
                { this.state.isDialogOpen &&
                    <AvailabilityModalWindow
                        open={this.state.isDialogOpen}
                        children={<AvailabilityModalDialog 
                                    headerProps={this.state.dialogTitle}
                                    body={this.state.dialogBody}
                                    actions={this.state.dialogAction}
                                />}
                        onClose={() => this.handleDialogStatusChange(false)}
                    />
                }
                {this.state.loading &&
                    <div style={{ 
                        position: "fixed",
                        display: 'flex',
                        flexDirection: "column",
                        flex: 1, 
                        width: '100%',
                        height: '100%',
                        alignItems: 'center', 
                        justifyContent: 'flex-start', 
                        paddingBottom: 30,
                        zIndex: 2000,
                        background: "rgba(0,0,0,0.8)"
                    }}>
                        <H2>{this.state.loadingMessage}</H2>
                        <CircularProgress size={ 100 }/>
                    </div>
                }
                { this.props.providerData 
                    ? <div
                        style={{
                            width: '100%',
                            backgroundColor: 'white'
                        }}
                    >
                        <FluidSection sectionMaxWidth={1200} backgroundColor="white">
                            <FlexColumn>
                                <BackgroundImg 
                                    backgroundImageURL={this.props.providerData.profilePhotoURL} 
                                    height={'120px'}
                                    width={'120px'}
                                    circle
                                    shadow
                                    style={{ marginRight: 40 }}
                                />
                                <Button 
                                    buttonColorAlt
                                    onClick={this.employeeEditorRedirect} 
                                    style={{ 
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'flex-start',
                                        fontSize: '1.2em',
                                        marginTop: 15,
                                        padding: '3px'
                                    }}
                                >
                                    <FontAwesomeIcon 
                                        icon={['fas', 'cogs']}
                                        style={{ display: "block" , margin: 0 }}
                                        size={"2x"}
                                        color={constants.color.light}
                                    />
                                </Button>
                                <H1 strong style={{ marginBottom: 0 }}>{`${this.props.providerData.name.first} ${this.props.providerData.name.last}`}</H1>
                                <H2 style={{ marginTop: 5 }}>{this.props.providerData.expertise}</H2>
                            </FlexColumn>
                        </FluidSection>
                    </div>
                    : <div
                        style={{
                            width: '100%',
                            backgroundColor: 'white'
                        }}
                    >
                        <FluidSection sectionMaxWidth={1200} backgroundColor="white">
                            <FlexColumn>
                                <BackgroundImg 
                                    backgroundImageURL={this.props.userData.profilePhotoURL} 
                                    height={'120px'}
                                    width={'120px'}
                                    circle
                                    shadow
                                    style={{ marginRight: 40 }}
                                />
                                <Button 
                                    buttonColorAlt
                                    onClick={this.employeeEditorRedirect} 
                                    style={{ 
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'flex-start',
                                        fontSize: '1.2em',
                                        marginTop: 15,
                                        padding: '3px'
                                    }}
                                >
                                    <FontAwesomeIcon 
                                        icon={['fas', 'cogs']}
                                        style={{ display: "block" , margin: 0 }}
                                        size={"2x"}
                                        color={constants.color.light}
                                    />
                                </Button>
                                <H1 strong style={{ marginBottom: 0 }}>{`${this.props.userData.firstName} ${this.props.userData.lastName}`}</H1>
                            </FlexColumn>
                        </FluidSection>
                    </div>
                }

                { this.props.providerData
                    ? <FluidSection style={{ padding: '40px 0px' }} sectionMaxWidth={590}>
                        <div>
                            <H2 altColor style={{paddingLeft: 16}}>
                                <FontAwesomeIcon 
                                    icon={['fas', 'redo-alt']}
                                    style={{ marginRight: 15, opacity: 0.6 }}
                                    // size={"2x"}
                                    color={constants.color.primaryDark}
                                />
                                Recurring Availability
                            </H2>
                            <FluidSection style={{maxWidth: 590, width: 'auto', paddingTop: 0}} sectionMinWidth={210} sectionMaxWidth={590}>
                                {recurringCardsJSX}
                            </FluidSection>
                        </div>
                        <FlexColumn style={{flex: 1}}>
                            <H2 altColor style={{paddingLeft: 16}}>
                                <FontAwesomeIcon 
                                    icon={['fas', 'calendar-alt']}
                                    style={{ marginRight: 15, opacity: 0.6 }}
                                    // size={"2x"}
                                    color={constants.color.primaryDark}
                                />
                                Exceptions to Regular Availability
                            </H2>
                            <StyledExceptionContainer id="StyledExceptionContainer">
                                <div>
                                    {exceptionsJSX.length > 0 && <H3 style={{ padding: 0, margin: 0, textAlign: 'center' }}>Dates with Modified Availability</H3>}
                                    {exceptionsJSX}
                                    
                                    {exceptionsJSX.length > 0 && <hr style={{ marginTop: 20, marginBottom: 20 }}/>}

                                    {daysOffJSX.length > 0 && <H3 style={{ padding: 0, margin: 0, textAlign: 'center' }}>Dates with No Availability</H3>}
                                    {daysOffJSX}

                                    <H2 style={{ padding: 0, margin: 0, marginTop: (daysOffJSX.length > 0 || exceptionsJSX.length > 0) ? 40 : 0 }}>
                                        Modify availability for a specific date:
                                    </H2>
                                    {this.state.showExceptionCard && <H3 style={{ alignSelf: 'center', textAlign: 'center' }}>
                                        (Remember to click "Save" when done.)
                                    </H3>}
                                    <FlexColumn>
                                        {<React.Fragment>
                                            {!(this.state.showExceptionCard || this.state.showDatePicker) && 
                                            <Button 
                                                buttonColorAlt
                                                onClick={openDatePickerDialog} 
                                                style={{ 
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'flex-start',
                                                    fontSize: '1.2em',
                                                    marginTop: 15,
                                                }}
                                            >
                                                <FontAwesomeIcon 
                                                    icon={['far', 'plus-square']}
                                                    style={{ display: "block" , marginRight: 10 }}
                                                    size={"2x"}
                                                    color={constants.color.light}
                                                />
                                                <H3 light style={{margin: 1}}>
                                                    Select Date to Modify
                                                </H3>
                                            </Button>}
                                           
                                            <div style={{ display: this.state.showExceptionCard ? 'none' : 'flex'}}>
                                                <DatePicker
                                                    style={{
                                                        opacity: 0,
                                                        display: 'flex',
                                                        flex: 1,
                                                        alignSelf: 'stretch',
                                                        alignItems: 'center', 
                                                        justifyContent: 'flex-start',
                                                        borderRadius: 12,
                                                        borderColor: 'transparent',
                                                        fontSize: 14,
                                                        cursor: 'pointer',
                                                        display: 'block',
                                                    }}
                                                    defaultDate={this.state.defaultDate}
                                                    minDate={this.state.defaultDate}
                                                    onChange={this.showExceptionCard}
                                                    onDismiss={this.hideDatePicker}
                                                    ref={datePickerRef}
                                                />
                                            </div>
                                            </React.Fragment>
                                        }
                                    </FlexColumn>
                                    {this.state.showExceptionCard && this.state.exceptionCardData &&
                                        <StyledCardComponent 
                                            cardName={this.state.exceptionCardData.title} 
                                            title={this.state.exceptionCardData.title} 
                                            timeBlocks={this.state.exceptionCardData.timeBlocks} 
                                            showDeleteConfirmationDialog={this.showDeleteConfirmationDialog} 
                                            deleteType={this.state.exceptionCardData.deleteType}
                                            addEditAvailability={this.state.exceptionCardData.addEditAvailability} 
                                            grabEndTime={this.state.exceptionCardData.grabEndTime} 
                                            grabStartTime={this.state.exceptionCardData.grabStartTime} 
                                            saveNewException={this.state.exceptionCardData.saveNewException}
                                            exceptionCardData={this.state.exceptionCardData}
                                            getDialogContent={this.getDialogContent}
                                            toggleExceptionCard={() => this.setState({showExceptionCard: false})}
                                        />
                                    }
                                </div>
                            </StyledExceptionContainer>
                        </FlexColumn>
                    </FluidSection>
                    : <FlexColumn>
                        <h2 style={{color:'lightgrey'}}>There are currently no dashboard options for this user type.</h2>
                    </FlexColumn>
                }
            </FlexColumn>
        );
    };
};

const mapStateToProps = ({ provider, availability, client }) => ({
    providerData: (provider.selectedProvider) ? provider.selectedProvider : null,
    availability: (availability.availability) ? availability.availability : null,
    userData: client.clientData,
    exceptions: (availability.exceptions) ? availability.exceptions : null,
    datesOff: (availability.localDaysOff) ? availability.localDaysOff : null,
    availabilityUpdateStatus: (availability.availabilityUpdateStatus) ? availability.availabilityUpdateStatus : null,
});

export default withRouter(connect(mapStateToProps, actions)(ProviderContainer));


// WEBPACK FOOTER //
// ./src/js/containers/ProviderContainer/index.jsx